module.exports = __webpack_public_path__ + "static/media/21.bf7c3002.jpg";